module.exports = __webpack_public_path__ + "61292fcde174f1b649bf26d4150e21c7.svg";